import React from 'react';
import Constants from "../../utils/constants";
import { Container, Button } from "../../utils/ui";
import { AuthUIWrapper } from './style';
import Logo from '../../components/logo';

export default function Authentication() {
    const { PAGE_HEADER, ASSETS,LOGIN_OPTIONS } = Constants;

    const login=()=>{
        window.location.href=`https://app.clickup.com/api?client_id=${Constants.CREDENTIALS.CLIENT_ID}&redirect_uri=${Constants.REDIRECTION_URL}`
    }

    return (
        <>
            <Container sx={{ height: '100%' }}>
                <AuthUIWrapper>
                    <Logo />
                    <div className='pageHeader'>{PAGE_HEADER.LOGIN}</div>
                    <div className='loginOptionListContainer'>
                        {LOGIN_OPTIONS.map((option, index) => <div key={index}><Button onClick={login} className='loginOption'><img src={option.logo.path} alt={option.logo.altText} className="loginOptionLogo" />{option.text}</Button></div>)}
                    </div>
                </AuthUIWrapper>
            </Container>
        </>
    )
}